import React from 'react'
import { DealsTable } from 'components/Tables/DealsTable/DealsTable'
import { ContactCompany } from 'models/companies'
import { CompanyModal } from '../CompanyModal'

interface DealsModalProps {
  show: boolean
  onHide: () => void
  contactCompany: ContactCompany
  forDoorProxyId?: number
  companyName?: string
}

export function DealsModal({
  show,
  onHide,
  contactCompany,
  forDoorProxyId,
  companyName,
}: DealsModalProps) {
  const TABLE_KEY = forDoorProxyId
    ? `deals-modal-door-${forDoorProxyId}`
    : `deals-modal-company-${contactCompany.id}`

  return (
    <CompanyModal
      show={show}
      onHide={onHide}
      companyName={companyName || contactCompany.name}
      modalTitle="Deals"
    >
      <DealsTable
        useReports={false}
        tableKey={TABLE_KEY}
        forCompany={contactCompany as any}
        forDoorProxyId={forDoorProxyId}
        enablePagination={true}
        disableUrlPagination
        showCompanyColumn={false}
      />
    </CompanyModal>
  )
}
